import { BaseURL } from '../../../base/env';
import DetailModal from '../ProductItem/DetailModal/DetailModal';
import useProductItem from '../ProductItem/useProductItem';
import styles from './Campaign.module.css';
import CountDown from './CountDown/CountDown';
import useCampaign from './useCampaign';

const Campaign = () => {
  const { Gif, GifBackColor, GifUrlData } = useCampaign();
  const [
    shareModal, //eslint-disable-line
    setShareModal,
    isModalVisible,
    HideModal,
    showModal_visible,
    add_to_cart,
    store,
    history
  ] = useProductItem();

  if (!Gif || !GifBackColor) {
    return null;
  }

  if (GifUrlData?.is_external_url) {
    return (
      <a
        className={styles.Campaign}
        href={GifUrlData?.url}
        rel="noreferrer"
        style={{ backgroundColor: GifBackColor || '#f7f7f7' }}
        target="_blank">
        <img alt="campagin" className={styles.Image} src={`${BaseURL + Gif}`} />
      </a>
    );
  }

  return (
    <div
      className={`campaign ${styles.Campaign}`}
      style={{ backgroundColor: GifBackColor || '#f7f7f7' }}>
      <img
        alt="campagin"
        className={styles.Image}
        onClick={() => {
          if (GifUrlData.product) {
            showModal_visible(true);
          } else if (GifUrlData.url) {
            history.push(GifUrlData.url);
          }
        }}
        src={`${BaseURL + Gif}`}
      />
      <CountDown
        code={GifUrlData?.code}
        color={GifUrlData?.color}
        ended_at={GifUrlData?.ended_at}
        is_active={GifUrlData?.is_active}
        now={GifUrlData?.now}
        position={GifUrlData?.position}
        started_at={GifUrlData?.started_at}
      />
      <DetailModal
        add_to_cart={add_to_cart}
        data={GifUrlData?.product ? GifUrlData?.product : {}}
        HideModal={HideModal}
        isModalVisible={isModalVisible}
        setShareModal={setShareModal}
        showShare={false}
        store={store}
      />
    </div>
  );
};

export default Campaign;
